<template>
  <Photos year="2024" :min-date="1704067200" :max-date="1735689600" date-text="March 12&ndash;15" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
